module.exports = __webpack_public_path__ + "static/media/about.0e414ca1.png";